import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { Indicator, Group, Text, Anchor, Stack } from '@mantine/core';

import { HeadquarterContext } from 'context/HeadquarterContext';
import { OVERVIEW_PATH, PBB_PATH } from 'constants/path';
import { setPBBBannerRedirect } from 'helpers/preferredByBusiness';

export const PBBStatus: FunctionComponent = () => {
  const { headquarter, location } = useContext(HeadquarterContext);
  const navigate = useNavigate();

  const { matched_locations: matchedLocations, unmatched_locations: unmatchedLocations } =
    headquarter.google_business || {};

  const isLocationMatched = matchedLocations?.includes(location.id) ?? false;
  // locations in neither list are not OBN + Google ordering enabled, so PBB does not apply
  const isLocationEligible = isLocationMatched || !!unmatchedLocations?.includes(location.id);

  if (!isLocationEligible) {
    return null;
  }

  const handleLearnMoreClick = () => {
    setPBBBannerRedirect(location.id, OVERVIEW_PATH);
    void navigate(PBB_PATH);
  };

  return (
    <Group gap="xs2" align="flex-start">
      <Indicator
        variant={isLocationMatched ? 'active' : 'neutral'}
        label={isLocationMatched ? 'on' : 'off'}
      />
      <Stack gap="xs3">
        <Text variant="sublabel-xs">Google Preferred by Business</Text>
        <Anchor
          component="button"
          variant="sublabel"
          size="xs"
          onClick={handleLearnMoreClick}
          w="fit-content"
        >
          Learn More
        </Anchor>
      </Stack>
    </Group>
  );
};
